












import FeedbackComponent from '@/components/base/FeedbackComponent'
import MemberActivityLoanGrid from "@/components/dashboard/find-member-or-employer/tabs/MemberActivityLoanGrid.vue";
import MemberLoanProcessGrid from "@/components/dashboard/find-member-or-employer/tabs/MemberLoanProcessGrid.vue";
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'

@Component({
  components: {
    MemberActivityLoanGrid,
    MemberLoanProcessGrid
  }
})
export default class MemberLoanGrids extends FeedbackComponent {

  @Prop(String) memberIdNum!: string;

}


